import type { ObjectMapping } from '@shared/types/utils';

export const RESULT_TYPE: ObjectMapping = {
  UNSET_RESULT_TYPE: 'UNSET_RESULT_TYPE',
  AUTO_SUGGEST: 'AUTO_SUGGEST',
  POPULAR: 'POPULAR',
  RECENT: 'RECENT',
  CURRENT_LOCATION: 'CURRENT_LOCATION',
  SUBITEM: 'SUBITEM',
};
